import { ref, onMounted, onUnmounted } from "vue";
import { useAuthStore } from "@/stores/auth";

export function useBrowserSecurity() {
  const isSecurityEnabled = ref(true);
  const authStore = useAuthStore();

  // Disable right-click context menu
  const disableRightClick = (e) => {
    if (!authStore.isAuthenticated) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  };

  // Disable F12, Ctrl+Shift+I, Ctrl+U, Ctrl+S, etc.
  const disableKeyboardShortcuts = (e) => {
    if (!authStore.isAuthenticated) {
      // F12 - Developer Tools
      if (e.key === "F12") {
        e.preventDefault();
        return false;
      }

      // Ctrl+Shift+I - Developer Tools
      if (e.ctrlKey && e.shiftKey && e.key === "I") {
        e.preventDefault();
        return false;
      }

      // Ctrl+Shift+C - Element Inspector
      if (e.ctrlKey && e.shiftKey && e.key === "C") {
        e.preventDefault();
        return false;
      }

      // Ctrl+Shift+J - Console
      if (e.ctrlKey && e.shiftKey && e.key === "J") {
        e.preventDefault();
        return false;
      }

      // Ctrl+U - View Source
      if (e.ctrlKey && e.key === "u") {
        e.preventDefault();
        return false;
      }

      // Ctrl+S - Save Page
      if (e.ctrlKey && e.key === "s") {
        e.preventDefault();
        return false;
      }

      // Ctrl+A - Select All
      if (e.ctrlKey && e.key === "a") {
        e.preventDefault();
        return false;
      }

      // Ctrl+P - Print
      if (e.ctrlKey && e.key === "p") {
        e.preventDefault();
        return false;
      }
    }
  };

  // Disable text selection
  const disableTextSelection = () => {
    if (!authStore.isAuthenticated) {
      document.body.style.userSelect = "none";
      document.body.style.webkitUserSelect = "none";
      document.body.style.mozUserSelect = "none";
      document.body.style.msUserSelect = "none";
    } else {
      document.body.style.userSelect = "auto";
      document.body.style.webkitUserSelect = "auto";
      document.body.style.mozUserSelect = "auto";
      document.body.style.msUserSelect = "auto";
    }
  };

  // Detect Developer Tools
  const detectDevTools = () => {
    if (!authStore.isAuthenticated) {
      const threshold = 160;

      const checkDevTools = () => {
        if (
          window.outerHeight - window.innerHeight > threshold ||
          window.outerWidth - window.innerWidth > threshold
        ) {
          // Developer tools might be open
          document.body.innerHTML = `
            <div style="
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: #000;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
              font-family: Arial, sans-serif;
              z-index: 9999;
            ">
              <div style="text-align: center;">
                <h1>Access Restricted</h1>
                <p>Please close developer tools and refresh the page.</p>
                <button onclick="window.location.reload()" style="
                  background: #007bff;
                  color: white;
                  border: none;
                  padding: 10px 20px;
                  border-radius: 4px;
                  cursor: pointer;
                  margin-top: 20px;
                ">Refresh Page</button>
              </div>
            </div>
          `;
        }
      };

      // Check periodically
      const devToolsInterval = setInterval(checkDevTools, 1000);

      return () => clearInterval(devToolsInterval);
    }
  };

  // Console warning
  const consoleWarning = () => {
    if (!authStore.isAuthenticated) {
      console.clear();
      console.log("%cSTOP!", "color: red; font-size: 50px; font-weight: bold;");
      console.log(
        '%cThis is a browser feature intended for developers. If someone told you to copy-paste something here to enable a feature or "hack" someone\'s account, it is a scam and will give them access to your account.',
        "color: red; font-size: 16px;"
      );
    }
  };

  // Disable drag and drop
  const disableDragDrop = (e) => {
    if (!authStore.isAuthenticated) {
      e.preventDefault();
      return false;
    }
  };

  // Disable image saving
  const disableImageSaving = (e) => {
    if (!authStore.isAuthenticated && e.target.tagName === "IMG") {
      e.preventDefault();
      return false;
    }
  };

  const enableSecurity = () => {
    if (typeof window !== "undefined") {
      document.addEventListener("contextmenu", disableRightClick);
      document.addEventListener("keydown", disableKeyboardShortcuts);
      document.addEventListener("dragstart", disableDragDrop);
      document.addEventListener("drop", disableDragDrop);
      document.addEventListener("dragover", disableDragDrop);
      document.addEventListener("mousedown", disableImageSaving);

      disableTextSelection();
      consoleWarning();

      const cleanupDevTools = detectDevTools();

      return cleanupDevTools;
    }
  };

  const disableSecurity = () => {
    if (typeof window !== "undefined") {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", disableKeyboardShortcuts);
      document.removeEventListener("dragstart", disableDragDrop);
      document.removeEventListener("drop", disableDragDrop);
      document.removeEventListener("dragover", disableDragDrop);
      document.removeEventListener("mousedown", disableImageSaving);

      // Re-enable text selection
      document.body.style.userSelect = "auto";
      document.body.style.webkitUserSelect = "auto";
      document.body.style.mozUserSelect = "auto";
      document.body.style.msUserSelect = "auto";
    }
  };

  return {
    isSecurityEnabled,
    enableSecurity,
    disableSecurity,
  };
}
